<template>
  <component
    :is="component"
    v-bind="props"
    @setup-error="handleSetupError"
    @setup-start="handleSetupStart"
    @setup-success="handleSetupSuccess"
    @submit-error="handleSubmitError"
    @submit-start="handleSubmitStart"
    @submit-success="handleSubmitSuccess"
  />
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from '#app'
import { computed, defineAsyncComponent } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import type {
  PaymentFormAdapterEmits,
  PaymentFormAdapterProps,
} from '../../../form-common/types'

const props = defineProps<PaymentFormAdapterProps>()
const emit = defineEmits<PaymentFormAdapterEmits>()

const { payment } = useRuntimeConfig().public
const { market } = useMarketplace()

const AdyenCardAdapterV5 = defineAsyncComponent(
  () => import('./AdyenCardAdapterV5.vue'),
)
const AdyenCardAdapterV6 = defineAsyncComponent(
  () => import('./AdyenCardAdapterV6.vue'),
)

const component = computed(() => {
  return payment.FF_ADYEN_WEB_V6_COUNTRIES.includes(market.countryCode)
    ? AdyenCardAdapterV6
    : AdyenCardAdapterV5
})

function handleSetupStart(...args: PaymentFormAdapterEmits['setup-start']) {
  emit('setup-start', ...args)
}

function handleSetupSuccess(...args: PaymentFormAdapterEmits['setup-success']) {
  emit('setup-success', ...args)
}

function handleSetupError(...args: PaymentFormAdapterEmits['setup-error']) {
  emit('setup-error', ...args)
}

function handleSubmitStart(...args: PaymentFormAdapterEmits['submit-start']) {
  emit('submit-start', ...args)
}

function handleSubmitError(...args: PaymentFormAdapterEmits['submit-error']) {
  emit('submit-error', ...args)
}

function handleSubmitSuccess(
  ...args: PaymentFormAdapterEmits['submit-success']
) {
  emit('submit-success', ...args)
}
</script>
